module.exports = __webpack_public_path__ + "img/popup_battery_4.88c61d38.svg";